import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export const store = new Vuex.Store({
    state: {
        "listings": [
        ]
    },
    getters: {
        allListings: state => {
          return state.listings.reduce((a, v) => {
            if (v.status !== '') {
              a.push(v);
            }
            return a;
          }, []);
        },
        soldListings: state => {
            return state.listings.reduce((a, v) => {
                if (v.status === 'Sold') {
                    a.push(v);
                }
                return a;
            }, []);
        },
        availableListings: state => {
            return state.listings.reduce((a, v) => {
                if (v.status === 'Available') {
                    a.push(v);
                }
                return a;
            }, []);
        }
    },
    mutations: {
        updateListings(state, payload) {
            state.listings = payload;
        }
    },
    actions: {
        loadListings: ({commit}) => {
            Vue.http.get('/static/listings.json')
                .then(response => response.json())
                .then(data => {
                    if (data) {
                        let listings = data.listings.map((listing, index) => {
                          listing.id = index;
                          return listing;
                        });
                        listings = listings.sort(function(a, b) {
                          let aSoldDate = a.soldDate || '00/00/0000';
                          if (!(aSoldDate.length === 0 || aSoldDate.length === 10)) {
                            console.error('bad sold date', a);
                            aSoldDate = '00/00/0000';
                          }
                          let bSoldDate = b.soldDate || '00/00/0000';
                          if (!(bSoldDate.length === 0 || bSoldDate.length === 10)) {
                            console.error('bad sold date', b);
                            bSoldDate = '00/00/0000';
                          }
                          const aDate = aSoldDate.substring(6) + aSoldDate.substring(0, 2) + aSoldDate.substring(3, 5);
                          const bDate = bSoldDate.substring(6) + bSoldDate.substring(0, 2) + bSoldDate.substring(3, 5);
                          return bDate.localeCompare(aDate);
                        });
                        commit('updateListings', listings);
                    }
                    else {
                        commit('updateListings', []);
                    }
                });
        }
    }
});



// WEBPACK FOOTER //
// ./src/store.js